/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function Highlight({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" fillRule="evenodd" d="M9.028 1.518A.6.6 0 1 0 7.955.982L5.521 5.85l-.004.007-.003.007-.456.912a2.6 2.6 0 0 0 1.006 3.404L4.33 13.65H1.45a.6.6 0 0 0 0 1.2h7.583a.6.6 0 0 0 .543-.343l1.04-2.082a2.6 2.6 0 0 0 3.098-1.32l1.543-3.087a.6.6 0 1 0-1.073-.536l-.815 1.63-6.51-3.255zM6.131 7.313l.191-.383 6.51 3.255-.19.383a1.4 1.4 0 0 1-1.88.626L6.758 9.191a1.4 1.4 0 0 1-.626-1.878m1.004 3.409L5.671 13.65h2.991l.866-1.732z" clipRule="evenodd" /></svg>;
}
;